<template>
	<div>
		<div class="midlle">
			<div class="myProject" v-if="loading">
				<div class="title">
					<span class="tit">我已发布的资源工具</span>
					<p>您已发布{{countInfo.num}}个资源工具，共计浏览<span>{{countInfo.hits_num}}</span>次,收藏<span>{{countInfo.collect_num}}</span>次</p>
				</div>
				<div class="myProject-main"  v-if='relesedList.total'>
					<div class="item" v-for="(item,index) in relesedList.data" :key="index"> 
						<div class="main">
							<div class="head">
								<div>浏览: <span>{{item.hits == null ? 0: item.hits}}</span></div>
								<div>收藏: <span>{{item.collect_num}}</span></div>
								<!-- <div>点赞: <span>{{item.like}}</span></div> -->
							</div>
							<div class="body">
								<div class="image" @click="goto(`/zyTools/?id=${item.id}`)">
									<img :src='getImgSrc(item.image)' alt="">
								</div>

								<div style="width: 100%;display: flex;justify-content: center;">
									<p
									style="font-size: 18px;overflow: hidden;width: 150px;text-align: center;text-overflow: ellipsis;white-space: nowrap;overflow: hidden; ">
											{{item.title}}
											</p>
								</div>
								<div class="status">
									<span style="color: red;" v-if="item.status == 0" > 已驳回</span>
									<span style="color: orange;" v-if="item.status == 0"  @click="$router.push('/zyTools/editDraft?id='+item.id)"> 去修改</span>
									<span v-if="item.status == 1"> 待审核</span>
									<span v-if="item.status== 2"> 公布中</span>
									<span v-if="item.status == 3"> 已投条</span>
									<span v-if="item.status == 4"> 执行中</span>
									<span v-if="item.status == 5"> 已归档</span>
									<span v-if="item.status == 6"> 已存挡</span>
								</div>
							</div>
						</div>
						<!-- <div class="bottom">
							<p v-if="item.status == 0">已过期，<span style="color: #0052D9;">去更新</span></p>
							<p v-else>有<span style="color: #0052D9;">{{item.new}}</span>条咨询</p>
						</div> -->
					</div>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="200"></el-empty>
				</div>
				<div class="body-mid-footer" @click="loadingMoreRelesed" v-if="relesedList.current_page < relesedList.last_page">
					加载更多<img src='../../../assets/images/darrwo.png' alt="">
				</div>
			</div>
			<div class="midlle-body">
				<div class="body-title">
					<div class="line"></div>
					<div style="margin-left: 20px;">平台活动/资源工具</div>
				</div>
				<div
					style="display:flex;align-items: center;justify-content: space-between;padding: 0 15px;margin-bottom: 15px;">
					<div style="display:flex;align-items: center;">

						<div style="display: flex;align-items: baseline;cursor: pointer;margin-left: 15px;" @click="sjShaixuan">
							时间<img src="../../../assets/images/shaixuan.png" alt="" style="width: 15px;height: 13px;">
						</div>
					</div>
					<el-radio-group v-model="checkedCities" @change="radioChange">
						 <el-radio  v-for="city in cities6" :label="city.id"  :key="city.id">{{city.name}}</el-radio>					
					</el-radio-group>
				</div>

				<div class="">


				</div>
				<el-table :data="tableData3.data" stripe style="width: 100%"  @cell-click='cc'>
					<el-table-column prop="type" label="类型" width="84" :resizable="false">
						<template >
							资源工具
						</template>
					</el-table-column>
					<el-table-column label="类别" width="60" :resizable="false">
						<template>
							<p v-for="(item,index) in checkLb" :key="index">{{item.name}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="标题" width="135" :resizable="false">
					</el-table-column>
					<el-table-column label="状态" width="75" :resizable="false">
						<template slot-scope="scope">
							<span v-if="scope.row.status == 1"> 待审核</span>
							<span v-if="scope.row.status == 2"> 公布中</span>
							<span v-if="scope.row.status == 3"> 已投条</span>
							<span v-if="scope.row.status == 4"> 执行中</span>
							<span v-if="scope.row.status == 5"> 已归档</span>
							<span v-if="scope.row.status == 6"> 已存挡</span>
						</template>
					</el-table-column>
					<el-table-column  label="当前状态开始时间" width="135" :resizable="false">
						
						<template slot-scope="scope">
							<p>{{timeConversion(scope.row.updatetime)}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="user_name" label="当前状态用户" width="120" :resizable="false">
					</el-table-column>
					<el-table-column label="项目金额" width="123" :resizable="false">
						<template slot-scope="scope">
							<p>{{scope.row.price}}元</p>
							
						</template>
					</el-table-column>
					<el-table-column label="查看详情" width="106" :resizable="false">
						<template slot-scope="scope">
							<div class="link" style="color: #0052D9 !important;" @click="goto(`/zyTools/zyQiuzDetail?id=${scope.row.id}`)">
								详请链接
							</div>
						</template>
						
					</el-table-column>

				</el-table>
				<div style="display: flex;justify-content: flex-end;">
					<div class="loading" @click="loadingMoreList" v-if="tableData3.current_page < tableData3.last_page">
						<img src='../../../assets/images/loading.png' > 加载更多
					</div>
				</div>
				<el-dialog :lock-scroll="false" title="金额认定说明" :visible.sync="centerDialogVisible" width=" 732px"
					center>
					<p style="">
					<p style="text-indent: 2em;color: #888;line-height: 25px;">
						银行卡认证确认金额请您注意以下4 点： 1.请您注意在收到我们给您汇款成功，需要确认金额的邮件后再查询您在银行认证第三步登记的银行账户明细。
						2.需要查询的是账户明细中最近期的打款金额，您已经有过5次提现成功的记录，请您查询在收到第6次的款项后，将第6次的单笔款项输入，而不是账户总额或者几次打款的累计。3.我们给您汇入的款项都小于1元，而且您在收支明细中是可以查到支付宝给您打的单笔金额的。4.输入的时候注意在半角状态下输入，精确到小数点后两位。符合以上4
						点后，您可以登录www.alipay.com－您的支付宝账户，进入后看到“您好，***
						欢迎回来。”的下面“您的支付宝认证正在进行中，请点此查看详细信息”，－点击查看进入银行账户核实，就会有个确认金额的入口，在此入口输入我们支付宝给您打的小于1.00元的款项就可以了，确认成功后，您的银行卡认证就成功了。请您注意您有两次机会确认此金额。如果两次金额确认错误，银行卡认证会失败，您需要重新申请银行卡认证。感谢您的支持！
					</p>
					<br>
					<p style="text-indent: 2em;color: #888;line-height: 25px;">
						银行卡认证确认金额请您注意以下4 点： 1.请您注意在收到我们给您汇款成功，需要确认金额的邮件后再查询您在银行认证第三步登记的银行账户明细。
						2.需要查询的是账户明细中最此查看详细信息”，－点击查看进入银行账户核实，就会有个确认金额的入口，在此入口输入我们支付宝给您打的小于1.00元的款项就可以了，确认成功后，您的银行卡认证就成功了。请您注意您有两次机会确认此金额。如果两次金额确认错误，银行卡认证会失败，您需要重新申请银行卡认证。感谢您的支持！
					</p>
					</p>
					<div
						style="height: 112px;background: #0052D9;margin-top: 30px;color: white;padding: 20px 30px;box-sizing: border-box;">
						<h3 style="font-size: 20px;margin-bottom: 25px;">平台联系方式</h3>
						<p style="font-size: 18px;"><span><i class="el-icon-message"></i><span
									style="margin-left: 8px;">PINGT@163.COM</span></span> <span
								style="margin-left: 80px;"><i class="el-icon-phone-outline"></i><span
									style="margin-left: 8px;">13596823578</span></span></p>
					</div>

				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				centerDialogVisible: false,
				cities6: [{id:1,name:'发布'}, {id:2,name:'交互'},{id:3,name:'收藏'},{id:4,name:'点赞'},{id:5,name:'转发'},],
				checkedCities:1,
				myProject: [],
				tableData3: [],
				serveData: {
					type: 2, //1项目需求2资源工具池3解决方案4产品服务
					order: 'id desc', //id asc
					cate: 1 ,//	1发布2交互3收藏4点赞5转发
					page:1
				},
				countInfo:{},
				relesedList:[],
				relesedPage:1,
				loading:false
			}
		},
		created() {
			this.getMyProject()
			this.getMyPlatformCount()
			this.getmyProjectRelesed()
		},
		computed:{
			checkLb(){
				return this.cities6.filter(item=> this.checkedCities==item.id)
			}
		},
		methods: {
			async getmyProjectRelesed(type){
				const relesed = await this.$api.myToolsRelesed({page:this.relesedPage,cate:1})
				if(type == 1){
					this.relesedList.data = this.relesedList.data.concat(relesed.data.data) 
					this.relesedList.last_page = relesed.data.last_page
					this.relesedList.current_page = relesed.data.current_page
				}else{
					this.relesedList = relesed.data
				}
				this.loading = true
				console.log(relesed);
			},
			loadingMoreRelesed(){
				if(this.relesedList.current_page<this.relesedList.last_page){
					this.relesedPage++
					this.getmyProjectRelesed(1)
				}
			},
			async getMyPlatformCount(){
				const count = await this.$api.myPlatformToolsCount()
				this.countInfo = count.data
				console.log(count);
			},
			radioChange(e){
				this.serveData.cate = e
				this.serveData.page = 1
				this.getMyProject()
			},
			loadingMoreList(){
				if(this.tableData3.current_page < this.tableData3.last_page){
					this.serveData.page++
					this.getMyProject(1)
				}
			},
			sjShaixuan(){
				this.serveData.order == 'id desc' ? this.serveData.order = 'id asc' : this.serveData.order = 'id desc'
				this.getMyProject()
				this.serveData.page = 1
			},
			async getMyProject(type) {
				const pro = await this.$api.myPlatformActivity({
					...this.serveData
				})
				if(type == 1){
					this.tableData3.data = this.tableData3.data.concat(pro.data.data)
					this.tableData3.last_page = pro.data.last_page
					this.tableData3.current_page = pro.data.current_page
				}else{
					this.tableData3 = pro.data
				}
				console.log(pro);
			},
			cc(row, column, cell, event) {
				console.log(row, column.label, cell, event);
			},
			goto(url) {
				this.$router.push(url)
			},
		}
	}
</script>
<style>
	/* .el-radio__label {
		color: black;
	}
	
	.radio {
		position: relative;
		display: inline-block;
		margin-right: 12px;
	}
	
	.radio input {
		width: 15px;
		height: 15px;
		appearance: none;
		-webkit-appearance: none;
		opacity: 0;
		outline: none;
	}
	
	.radio label {
		position: absolute;
		left: 0;
		top: 6px;
		width: 15px;
		height: 15px;
		border: 1px solid #bcbcbc;
	}
	
	.el-radio__inner {
		border-radius: 0;
	}
	
	.el-radio__inner::after {
		content: "";
		position: absolute;
		text-align: center;
		border-radius: 0;
		width: 14px;
		height: 14px;
		content: "✓";
		color: #fff;
		font-weight: bold;
		background-color: #0052D9;
	} */
	
	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #0052D9;
		border-color: #0052D9;
	}

	.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #0052D9;
	}
</style>
<style lang="less" scoped>
	.midlle-body {
		padding-bottom: 10px;

		/deep/.link {
			color: #0052D9;
			cursor: pointer;
			display: flex;
			justify-content: space-around;
		}

		margin-top: 20px;
		padding-top: 20px;
		box-sizing: border-box;
		background: white;

		.body-title {
			color: #0052D9;
			display: flex;
			margin-bottom: 20px;
			font-weight: bold;
			font-size: 18px;

			.line {
				width: 4px;
				height: 22px;
				background: #0052D9;
			}
		}

		.loading {
			cursor: pointer;
			width: 116px;
			height: 40px;
			background: #F6F6F6;
			display: flex;
			align-items: center;
			margin: 10px;
			margin-bottom: 0;
			justify-content: center;
		}

	}

	.midlle {
		.myProject {
			.body-mid-footer {
				width: 96%;
				margin: 0 auto;
				display: flex;
				box-sizing: border-box;
				height: 50px;
				background: #F6F6F6;
				justify-content: center;
				font-size: 18px;
				cursor: pointer;
				align-items: center;

				&>img {
					margin-left: 20px;
					width: 16px;
					height: 16px;
				}
			}

			.myProject-main {
				display: flex;
				flex-wrap: wrap;

				.item {
					margin-bottom: 20px;
					margin-left: 10px;
					.bottom {
						margin-top: 15px;
						text-align: center;
						color: #888;
						width: 100%;
						height: 25px;
						background: #F6F6F6;
					}

					.main:hover {
						transform: scale(1.02);
						box-shadow: 0 0 10px #d0d0d0;
					}

					.main {
						transition: all .3s;
						position: relative;
						align-content: flex-start;
						width: 256px;
						height: 276px;
						border: 1px solid #8b8b8b;
						display: flex;
						flex-wrap: wrap;
						padding: 15px 20px;
						box-sizing: border-box;
						justify-content: center;

						.body {
							.status {
								position: absolute;
								bottom: 15px;

								p {
									color: #888;
									display: flex;
									align-items: center;
								}
							}

							margin-top: 20px;
							display: flex;
							justify-content: center;
							flex-wrap: wrap;

							.image {
								cursor: pointer;
								width: 100px;
								height: 100px;
								border-radius: 50%;
								overflow: hidden;
								margin-bottom: 25px;

								img {
									width: 100%;
									height: 100%;
								}
							}
						}

					}

					.head {
						height: 20px;

						span {
							color: #0052D9;
						}

						width: 100%;
						font-size: 14px;
						justify-content: space-around;
						display: flex;
					}
				}

				padding: 25px 15px;
			}

			.title {
				display: flex;
				height: 40px;
				background: #E5EDFB;
				align-items: center;

				p {
					font-size: 14px;
					color: black;
					margin-left: 10px;

					span {
						color: #0052D9;
					}
				}

				.tit {
					display: inline-block;
					padding: 0 20px;
					background: #0052D9;
					height: 40px;
					line-height: 40px;
					color: white;
					font-size: 18px;
					border-radius: 0px 20px 20px 0px;
					font-weight: bold;
				}
			}

			width: 840px;
			padding: 20px 0;
			background: #FFFFFF;
		}

		width: 880px;
		padding: 0 20px;
		box-sizing: border-box;
	}
</style>